import SubmissionStatus from './SubmissionStatus';

export default SubmissionStatus;
